/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Status_FailedInputs */



/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Embed_Captions_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_status_failed = /** @type {((inputs?: Embed_Captions_Status_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Status_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echoue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fallito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неуспешный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fallido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("失败的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("失敗した")
	if (locale === "hi") return /** @type {LocalizedString} */ ("असफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fracassado")
	return /** @type {LocalizedString} */ ("Failed")
});